import React, {Component} from 'react';
import './TermsAndConditions.less';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';
import {Switch} from '@homeaway/react-form-components';
import {apiPost} from '../../util/api.client';
import ClientLogger from '../../util/clientLogger';


class TermsAndConditionsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            TandCSwitch: this.props.TandCSwitch,
        };
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.props.setMarketingOptOut(true);
    }

    checkStatus(response) {
        switch (response.status) {
            case 200:
                return response.json();
            default:
                ClientLogger.logError(`An error has occurred : ${response.status} - ${response.statusText}`);
                break;
        }
        return null;
    }

    handleTCClicked = () => {
        if (this.state.TandCSwitch) {
            const statusRequest = {
                'emailAddress': this.props.emailAddress,
                'site': this.props.site,
                'sourceUrl': window.location.href,
                'source': 'lightbox.signup.inquiry'
            };
            // update this so we don't have to worry about rolling back the edge rule in test and stage
            const url = '/newsletter-subscriptions/v1/subscriptions';
            apiPost(url, statusRequest).then(this.checkStatus);
        }
        this.props.updatePage('postTandC');
    }

    handleToggleClicked = (event) => {
        this.setState({[event.target.name]: event.target.checked});
        this.props.setMarketingOptOut(!event.target.checked);
    }

    render() {
        let buttonLabel = this.props.lingua.read('lex.button.accept.terms.conditions');
        let options = {'siteName': this.props.siteName};
        let text = this.props.lingua.read('lex.signup.termsandcondtions');
        return (
            <div className="TermsAndConditionsComponent">
                <form className="TermsAndComponentForm text-center">
                    <div className="terms-and-conditions" href=""><label className="text-default" dangerouslySetInnerHTML={{__html: text}}/></div>
                    <ButtonPrimary label={buttonLabel} onClick={this.handleTCClicked} className="btn-lg">
                        <LoadingOverlay loading={this.props.isWaiting}/>
                    </ButtonPrimary>
                    <div className="vacation-ideas-container">
                        <div className="vacation-ideas" href="">{this.props.lingua.read('lex.signup.vacation.ideas', options)}</div>
                        <div className="tc-toggle-switch">
                            <Switch
                                name="TandCSwitch"
                                id="toggle-switch"
                                onChange={this.handleToggleClicked}
                                size="sm"
                            />
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default TermsAndConditionsComponent;
